import ContractingDetailSection from 'features/contracting/sections/ContractingDetailSection';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const portalConfig = loadPortalConfig();

type RouteProps = {
  contractingId: string;
}

const ContractingDetailAdminPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { contractingId } = useParams<RouteProps>();

  // render
  return (
    <RenderWrapper isVisible={() => portalConfig.enableContracting}>
      <Header
        title={tLabels("contractingDetailAdminPage.title")}
        includeBreadcrumbs
        links={[
          { to: "/admin/contractings", text: tLabels("contractingsAdminPage.title") },
        ]}
      />
      <ModuleContent>
        <ContractingDetailSection 
          contractingId={contractingId} 
        />
      </ModuleContent>
    </RenderWrapper>
  );
}

export default ContractingDetailAdminPage;